import React from 'react';
import { Checkbox } from 'antd';

const TableCheckbox = props => {
    const { onSelect, checked, rowData } = props;

    return <Checkbox checked={checked} onChange={e => onSelect(e, rowData)} />;
};

export default TableCheckbox;
